import { useGetCompanyForSubdomainQuery } from "features/api/company"

export function getCurrentSubdomain(): string {
  if (typeof window === "undefined") return ""
  let subdomain = window.location.hostname.split(".")[0]
  if (subdomain === "localhost") {
    subdomain = process.env.NEXT_PUBLIC_LOCAL_DEV_SUBDOMAIN ?? "rdo"
  }
  return subdomain
}

export function useGetCompanyForCurrentSubdomain() {
  const subdomain = getCurrentSubdomain()
  return useGetCompanyForSubdomainQuery(subdomain, {
    skip: !subdomain,
  })
}
